/*
 * File: vue-holder.ts
 * File Created: 2024-09-24 10:15:44
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 10:20:39
 * Modified By: Val Liu
 * -----
 */

import Vue from "vue";

let vueHolder: Vue;
export const VueHolder = () => vueHolder ?? (vueHolder = new Vue());
